import { ModalLista } from "./ModalLista";

interface ModalListaProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  data: {
    codigo: string;
    descricao: string;
    linha?: string;
    porcentagemUso: number;
  }[];
}

export function ModalListaVidros({
  isOpen,
  onClose,
  title,
  data,
}: ModalListaProps) {
  return (
    <ModalLista
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      columns={[
        {
          field: "codigo",
          headerName: "Código",
          sortable: false,
          flex: 0.1,
        },
        {
          field: "descricao",
          headerName: "Descrição",
          sortable: false,
          flex: 0.2,
        },
        {
          field: "linha",
          headerName: "Linha",
          sortable: false,
          flex: 0.2,
        },
        {
          field: "porcentagemUso",
          headerName: "% uso",
          sortable: false,
          flex: 0.1,
        },
      ]}
      rows={data.map((d, index) => {
        return {
          ...d,
          id: index + 1,
        };
      })}
    />
  );
}
